export enum MATCH_INSIGHT_TYPE {
  IMAGE,
  URL,
  TIMELINE,
}

export enum SPORT_ISSUE_TYPE {
  POPULAR_SEARCH_TERM_NEWS,
  MATCH_INSIGHT,
}

export enum SPORT_TALK_PREVIEW_TYPE {
  ISSUE,
}

export enum SPORT_TALK_ITEM_TYPE {
  CHEER_FOR_TEAM,
  MATCH_TIMELINE,
}
